module.exports = __webpack_public_path__ + "static/img/tourism.ac59eec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Home/tourism.png
// module id = Ekii
// module chunks = 1